/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseOfferComponentDefinitionDto } from '../models';
// @ts-ignore
import type { BaseOfferDefinitionDto } from '../models';
// @ts-ignore
import type { OfferComponentDefinitionIdDto } from '../models';
// @ts-ignore
import type { OfferDefinitionDto } from '../models';
// @ts-ignore
import type { OfferDefinitionIdDto } from '../models';
// @ts-ignore
import type { OfferDefinitionSearchQueryDto } from '../models';
// @ts-ignore
import type { OfferDefinitionsSearchResponseDto } from '../models';
/**
 * RestOfferDefinitionsApi - axios parameter creator
 */
export const RestOfferDefinitionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add offer component definition
         * @param {number} offerDefinitionId 
         * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOfferComponentDefinition: async (offerDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerDefinitionId' is not null or undefined
            assertParamExists('addOfferComponentDefinition', 'offerDefinitionId', offerDefinitionId)
            // verify required parameter 'baseOfferComponentDefinitionDto' is not null or undefined
            assertParamExists('addOfferComponentDefinition', 'baseOfferComponentDefinitionDto', baseOfferComponentDefinitionDto)
            const localVarPath = `/api/offer-definitions/{offerDefinitionId}/components`
                .replace('{offerDefinitionId}', encodeURIComponent(String(offerDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOfferComponentDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create offer definition
         * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferDefinition: async (baseOfferDefinitionDto: BaseOfferDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOfferDefinitionDto' is not null or undefined
            assertParamExists('createOfferDefinition', 'baseOfferDefinitionDto', baseOfferDefinitionDto)
            const localVarPath = `/api/offer-definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOfferDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get offer definition by id
         * @param {number} offerDefinitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferDefinition: async (offerDefinitionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerDefinitionId' is not null or undefined
            assertParamExists('getOfferDefinition', 'offerDefinitionId', offerDefinitionId)
            const localVarPath = `/api/offer-definitions/{offerDefinitionId}`
                .replace('{offerDefinitionId}', encodeURIComponent(String(offerDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search offer definitions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferDefinitionSearchQueryDto} offerDefinitionSearchQueryDto Offer definitions search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOfferDefinitions: async (page: number, pageSize: number, offerDefinitionSearchQueryDto: OfferDefinitionSearchQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchOfferDefinitions', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchOfferDefinitions', 'pageSize', pageSize)
            // verify required parameter 'offerDefinitionSearchQueryDto' is not null or undefined
            assertParamExists('searchOfferDefinitions', 'offerDefinitionSearchQueryDto', offerDefinitionSearchQueryDto)
            const localVarPath = `/api/offer-definitions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerDefinitionSearchQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update offer component definition
         * @param {number} offerDefinitionId 
         * @param {number} offerComponentDefinitionId 
         * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferComponentDefinition: async (offerDefinitionId: number, offerComponentDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerDefinitionId' is not null or undefined
            assertParamExists('updateOfferComponentDefinition', 'offerDefinitionId', offerDefinitionId)
            // verify required parameter 'offerComponentDefinitionId' is not null or undefined
            assertParamExists('updateOfferComponentDefinition', 'offerComponentDefinitionId', offerComponentDefinitionId)
            // verify required parameter 'baseOfferComponentDefinitionDto' is not null or undefined
            assertParamExists('updateOfferComponentDefinition', 'baseOfferComponentDefinitionDto', baseOfferComponentDefinitionDto)
            const localVarPath = `/api/offer-definitions/{offerDefinitionId}/components/{offerComponentDefinitionId}`
                .replace('{offerDefinitionId}', encodeURIComponent(String(offerDefinitionId)))
                .replace('{offerComponentDefinitionId}', encodeURIComponent(String(offerComponentDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOfferComponentDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update offer definition
         * @param {number} offerDefinitionId 
         * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferDefinition: async (offerDefinitionId: number, baseOfferDefinitionDto: BaseOfferDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerDefinitionId' is not null or undefined
            assertParamExists('updateOfferDefinition', 'offerDefinitionId', offerDefinitionId)
            // verify required parameter 'baseOfferDefinitionDto' is not null or undefined
            assertParamExists('updateOfferDefinition', 'baseOfferDefinitionDto', baseOfferDefinitionDto)
            const localVarPath = `/api/offer-definitions/{offerDefinitionId}`
                .replace('{offerDefinitionId}', encodeURIComponent(String(offerDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOfferDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestOfferDefinitionsApi - functional programming interface
 */
export const RestOfferDefinitionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestOfferDefinitionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add offer component definition
         * @param {number} offerDefinitionId 
         * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOfferComponentDefinition(offerDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferComponentDefinitionIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOfferComponentDefinition(offerDefinitionId, baseOfferComponentDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferDefinitionsApi.addOfferComponentDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create offer definition
         * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOfferDefinition(baseOfferDefinitionDto: BaseOfferDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferDefinitionIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOfferDefinition(baseOfferDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferDefinitionsApi.createOfferDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get offer definition by id
         * @param {number} offerDefinitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferDefinition(offerDefinitionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferDefinitionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferDefinition(offerDefinitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferDefinitionsApi.getOfferDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search offer definitions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferDefinitionSearchQueryDto} offerDefinitionSearchQueryDto Offer definitions search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOfferDefinitions(page: number, pageSize: number, offerDefinitionSearchQueryDto: OfferDefinitionSearchQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferDefinitionsSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOfferDefinitions(page, pageSize, offerDefinitionSearchQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferDefinitionsApi.searchOfferDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update offer component definition
         * @param {number} offerDefinitionId 
         * @param {number} offerComponentDefinitionId 
         * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOfferComponentDefinition(offerDefinitionId: number, offerComponentDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOfferComponentDefinition(offerDefinitionId, offerComponentDefinitionId, baseOfferComponentDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferDefinitionsApi.updateOfferComponentDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update offer definition
         * @param {number} offerDefinitionId 
         * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOfferDefinition(offerDefinitionId: number, baseOfferDefinitionDto: BaseOfferDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOfferDefinition(offerDefinitionId, baseOfferDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferDefinitionsApi.updateOfferDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestOfferDefinitionsApi - factory interface
 */
export const RestOfferDefinitionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestOfferDefinitionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add offer component definition
         * @param {number} offerDefinitionId 
         * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOfferComponentDefinition(offerDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferComponentDefinitionIdDto> {
            return localVarFp.addOfferComponentDefinition(offerDefinitionId, baseOfferComponentDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create offer definition
         * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferDefinition(baseOfferDefinitionDto: BaseOfferDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferDefinitionIdDto> {
            return localVarFp.createOfferDefinition(baseOfferDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get offer definition by id
         * @param {number} offerDefinitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferDefinition(offerDefinitionId: number, options?: RawAxiosRequestConfig): AxiosPromise<OfferDefinitionDto> {
            return localVarFp.getOfferDefinition(offerDefinitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search offer definitions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferDefinitionSearchQueryDto} offerDefinitionSearchQueryDto Offer definitions search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOfferDefinitions(page: number, pageSize: number, offerDefinitionSearchQueryDto: OfferDefinitionSearchQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferDefinitionsSearchResponseDto> {
            return localVarFp.searchOfferDefinitions(page, pageSize, offerDefinitionSearchQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update offer component definition
         * @param {number} offerDefinitionId 
         * @param {number} offerComponentDefinitionId 
         * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferComponentDefinition(offerDefinitionId: number, offerComponentDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOfferComponentDefinition(offerDefinitionId, offerComponentDefinitionId, baseOfferComponentDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update offer definition
         * @param {number} offerDefinitionId 
         * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferDefinition(offerDefinitionId: number, baseOfferDefinitionDto: BaseOfferDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOfferDefinition(offerDefinitionId, baseOfferDefinitionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestOfferDefinitionsApi - interface
 */
export interface RestOfferDefinitionsApiInterface {
    /**
     * 
     * @summary Add offer component definition
     * @param {number} offerDefinitionId 
     * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addOfferComponentDefinition(offerDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferComponentDefinitionIdDto>;

    /**
     * 
     * @summary Create offer definition
     * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOfferDefinition(baseOfferDefinitionDto: BaseOfferDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferDefinitionIdDto>;

    /**
     * 
     * @summary Get offer definition by id
     * @param {number} offerDefinitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferDefinition(offerDefinitionId: number, options?: RawAxiosRequestConfig): AxiosPromise<OfferDefinitionDto>;

    /**
     * 
     * @summary Search offer definitions
     * @param {number} page 
     * @param {number} pageSize 
     * @param {OfferDefinitionSearchQueryDto} offerDefinitionSearchQueryDto Offer definitions search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchOfferDefinitions(page: number, pageSize: number, offerDefinitionSearchQueryDto: OfferDefinitionSearchQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferDefinitionsSearchResponseDto>;

    /**
     * 
     * @summary Update offer component definition
     * @param {number} offerDefinitionId 
     * @param {number} offerComponentDefinitionId 
     * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOfferComponentDefinition(offerDefinitionId: number, offerComponentDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update offer definition
     * @param {number} offerDefinitionId 
     * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOfferDefinition(offerDefinitionId: number, baseOfferDefinitionDto: BaseOfferDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestOfferDefinitionsApi - object-oriented interface
 */
export class RestOfferDefinitionsApi extends BaseAPI implements RestOfferDefinitionsApiInterface {
    /**
     * 
     * @summary Add offer component definition
     * @param {number} offerDefinitionId 
     * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addOfferComponentDefinition(offerDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options?: RawAxiosRequestConfig) {
        return RestOfferDefinitionsApiFp(this.configuration).addOfferComponentDefinition(offerDefinitionId, baseOfferComponentDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create offer definition
     * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOfferDefinition(baseOfferDefinitionDto: BaseOfferDefinitionDto, options?: RawAxiosRequestConfig) {
        return RestOfferDefinitionsApiFp(this.configuration).createOfferDefinition(baseOfferDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get offer definition by id
     * @param {number} offerDefinitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferDefinition(offerDefinitionId: number, options?: RawAxiosRequestConfig) {
        return RestOfferDefinitionsApiFp(this.configuration).getOfferDefinition(offerDefinitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search offer definitions
     * @param {number} page 
     * @param {number} pageSize 
     * @param {OfferDefinitionSearchQueryDto} offerDefinitionSearchQueryDto Offer definitions search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchOfferDefinitions(page: number, pageSize: number, offerDefinitionSearchQueryDto: OfferDefinitionSearchQueryDto, options?: RawAxiosRequestConfig) {
        return RestOfferDefinitionsApiFp(this.configuration).searchOfferDefinitions(page, pageSize, offerDefinitionSearchQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update offer component definition
     * @param {number} offerDefinitionId 
     * @param {number} offerComponentDefinitionId 
     * @param {BaseOfferComponentDefinitionDto} baseOfferComponentDefinitionDto Offer component definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOfferComponentDefinition(offerDefinitionId: number, offerComponentDefinitionId: number, baseOfferComponentDefinitionDto: BaseOfferComponentDefinitionDto, options?: RawAxiosRequestConfig) {
        return RestOfferDefinitionsApiFp(this.configuration).updateOfferComponentDefinition(offerDefinitionId, offerComponentDefinitionId, baseOfferComponentDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update offer definition
     * @param {number} offerDefinitionId 
     * @param {BaseOfferDefinitionDto} baseOfferDefinitionDto Offer definition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOfferDefinition(offerDefinitionId: number, baseOfferDefinitionDto: BaseOfferDefinitionDto, options?: RawAxiosRequestConfig) {
        return RestOfferDefinitionsApiFp(this.configuration).updateOfferDefinition(offerDefinitionId, baseOfferDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

